import { Link, useLocation } from "@tanstack/react-router";
import { twJoin } from "tailwind-merge";

const tabs = [
  {
    label: "Employees",
    href: "/employees",
  },
  {
    label: "Shifts",
    href: "/employees/shifts",
  },
];

export const EmployeesPageLayoutTabBar = () => {
  const location = useLocation();

  return (
    <div className="flex items-center gap-1">
      {tabs.map(({ label, href }) => (
        <Link
          className={twJoin(
            "rounded-full px-4 py-2",
            location.pathname === href
              ? "subtitle-sm bg-success/10 text-success"
              : "label text-foreground"
          )}
          key={href}
          to={href}
        >
          <p>{label}</p>
        </Link>
      ))}
    </div>
  );
};
